import { UsuarioOnline } from './UsuarioOnline.entity';

export class UsuarioUpdate {
    UsuarioOnline: UsuarioOnline;
    cambioPassword: boolean;
    passwordRepetir: string;
    oldPassword: string;
}
